<template>
  <DialogFull
    :steps="{ current: step, total: totalSteps }"
    :data="dialogSettings"
    progress
    @onStepBack="stepBack"
    @close="close"
  >
    <template v-slot:dialog.body>
      <RoleStep
        v-if="shouldStepViewBeShown(1)"
        @nextStep="stepForward"
        title="Role Template"
      />
      <BasicDetails
        :initial-template="bookingData.template"
        v-if="shouldStepViewBeShown(2) || ifStepHasAlreadyBeenCompleted(2)"
        v-show="shouldStepViewBeShown(2)"
        :validate="shouldStepViewBeShown(2) && shouldValidate"
        @change="updateData"
        @valid="stepForward"
        @invalid="shouldValidate = false"
        ref="basicDetails"
      />
      <InternalInformation
        v-if="shouldStepViewBeShown(3) || ifStepHasAlreadyBeenCompleted(3)"
        v-show="shouldStepViewBeShown(3)"
        :validate="shouldStepViewBeShown(3) && shouldValidate"
        :initial-template="bookingData.template"
        @valid="handleSubmit"
        @invalid="shouldValidate = false"
        @change="updateData"
      />
    </template>
    <template v-slot:dialog.action>
      <PrimaryButton
        :loading="isLoading"
        @click.native="validateStep"
        v-if="step < totalSteps"
      >
        Continue
      </PrimaryButton>
      <PrimaryButton @click.native="validateStep" :loading="isLoading" v-else>
        Create Role
      </PrimaryButton>
    </template>
  </DialogFull>
</template>

<script>
import BasicDetails from "@/views/bookings/NewBooking/steps/BasicDetails";
import RoleStep from "@/views/bookings/NewBooking/steps/RoleStep";
import InternalInformation from "@/views/bookings/NewBooking/steps/InternalInformation";
import DialogFull from "@/components/common/DialogFull";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import {
  BOOKINGS_NAMESPACE,
  CREATE_BOOKING
} from "@/store/modules/bookings/actions";
import { createNamespacedHelpers } from "vuex";
import { getAmountInApiFormat, getMonetaryAsNumber } from "@/utils/helpers";

const { mapActions } = createNamespacedHelpers(BOOKINGS_NAMESPACE);

export default {
  name: "NewBooking",
  components: {
    PrimaryButton,
    DialogFull,
    BasicDetails,
    RoleStep,
    InternalInformation
  },
  data() {
    return {
      step: 1,
      totalSteps: 3,
      savedStep: 1,
      bookingData: {},
      isLoading: false,
      shouldValidate: false
    };
  },
  computed: {
    isTemporaryJob() {
      return this.bookingData.contractType === "temporary";
    },
    dialogSettings() {
      return {
        dialog: this.isOpen,
        title: "New Role"
      };
    }
  },
  methods: {
    ...mapActions({
      createBooking: CREATE_BOOKING
    }),
    stepBack() {
      if (this.step > 1) {
        this.step -= 1;
      }
    },
    updateData(bookingData) {
      this.bookingData = { ...this.bookingData, ...bookingData };
      this.shouldValidate = false;
    },
    async getBookingData() {
      return {
        templateId: this.bookingData.template.id,
        title: this.bookingData.title,
        externalDescription: this.bookingData.externalDescription,
        location: this.bookingData.location,
        poNumber: this.bookingData.poNumber,
        postNumber: this.bookingData.postNumber,
        hireReason: this.bookingData.reason,
        client: this.bookingData.client,
        costCode: this.bookingData.client.costCode,
        internalOnly: this.bookingData.internalOnly,
        contractType: this.bookingData.contractType,
        workingHours: this.bookingData.workingHours,
        applyLinkOverride: this.bookingData.applyLinkOverride,
        startDate: this.bookingData.startDate,
        deadlineDate: this.bookingData.deadlineDate,
        vacancies: this.bookingData.vacancies,
        maximumApplications: this.bookingData.maximumApplications,
        internalDescription: this.bookingData.internalDescription,
        grade: this.bookingData.grade,
        anonymiseApplications: Boolean(this.bookingData.anonymiseApplications),
        salaryBandLower: getAmountInApiFormat(
          getMonetaryAsNumber(this.bookingData.salaryBandLower)
        ),
        salaryBandUpper: getAmountInApiFormat(
          getMonetaryAsNumber(this.bookingData.salaryBandUpper)
        )
      };
    },
    validateStep() {
      this.shouldValidate = true;
    },
    clearForm() {
      this.step = 1;
      this.savedStep = 1;
      this.bookingData = {};
    },
    async stepForward(bookingData) {
      this.bookingData = { ...this.bookingData, ...bookingData };
      this.step += 1;
      if (this.savedStep < this.totalSteps && this.step > this.savedStep) {
        this.savedStep += 1;
      }
      this.shouldValidate = false;
    },
    async handleSubmit() {
      this.isLoading = true;
      const bookingData = await this.getBookingData();
      const {
        data: { id: bookingId }
      } = await this.createBooking(bookingData);
      await this.$refs.basicDetails.uploadFiles(bookingId);
      this.clearForm();
      if (bookingId) {
        await this.$router.push(`/jobs/${bookingId}/details`);
      }
      this.$emit("close");
      this.isLoading = false;
    },
    close() {
      this.clearForm();
      this.$emit("close");
    },
    shouldStepViewBeShown(viewStep) {
      return viewStep <= this.totalSteps && this.step === viewStep;
    },
    ifStepHasAlreadyBeenCompleted(viewStep) {
      return viewStep <= this.savedStep;
    }
  },
  props: {
    isOpen: Boolean
  }
};
</script>

<style lang="scss"></style>
